import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { capturePageview } from "./posthog";

/**
 * Captures a PostHog pageview on every route change.
 * Must be rendered inside a BrowserRouter.
 */
export function PageviewTracker(): null {
    const location = useLocation();

    useEffect(() => {
        const url =
            window.location.origin + location.pathname + location.search;
        capturePageview(url);
    }, [location.pathname, location.search]);

    return null;
}
